module.exports = __webpack_public_path__ + "static/img/classical_cate.1832495.18324953.jpg";